// extracted by mini-css-extract-plugin
module.exports = {"upsElement":"UPSBanner_upsElement__C7FcB","richText":"UPSBanner_richText__t_SaD"};